import { render, staticRenderFns } from "./dynamicList.vue?vue&type=template&id=9871d66a&"
import script from "./dynamicList.vue?vue&type=script&lang=js&"
export * from "./dynamicList.vue?vue&type=script&lang=js&"
import style0 from "./dynamicList.vue?vue&type=style&index=0&id=9871d66a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports